export default {"src":"/_next/static/media/flag_us.1ac34f40.svg","height":19,"width":24,"blurWidth":0,"blurHeight":0};